var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "confirm-line-haul-connection"
  }, [_c('div', {
    staticClass: "animated fadeInDown"
  }, [_c('fieldset', [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "card-body1"
  }, [_c('vue-element-loading', {
    attrs: {
      "spinner": "line-scale",
      "color": "#FF6700",
      "active": _vm.isLoadingUpload
    },
    on: {
      "update:active": function($event) {
        _vm.isLoadingUpload = $event
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "card-body1 col-md-12",
    staticStyle: {
      "margin-bottom": "0rem",
      "padding": "0px",
      "background-color": "white"
    }
  }, _vm._l((_vm.tabs), function(tab) {
    return _c('button', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (tab.key === 'print' || _vm.isCameraAccess),
        expression: "tab.key === 'print' || isCameraAccess"
      }],
      key: tab.key,
      class: ['tab-button', {
        active: _vm.currentTab === tab.key
      }],
      style: (("" + ((_vm.tabs.length==1) ? 'width: 100%;' : ''))),
      attrs: {
        "id": tab.value
      },
      on: {
        "click": function($event) {
          _vm.currentTab = tab.key;
          _vm.secondFunction(tab);
        }
      }
    }, [_vm._v("\n            " + _vm._s(tab.value) + "\n          ")])
  }), 0), _vm._v(" "), _c('fieldset', [(_vm.currentTab == 'upload') ? _c('b-card', [_c('form', {
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.onUploadSubmit.apply(null, arguments)
      }
    }
  }, [_c('fieldset', [_c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-4"
  }, [_c('label', [_vm._v("Facility Camera Config ")]), _c('span', {
    staticClass: "text-danger"
  }, [_vm._v(" *")]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-file'></i>"
    }
  }, [_c('input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: true
      }),
      expression: "{required:true}"
    }],
    class: {
      'form-control': true, 'error': _vm.errors.has('configFile')
    },
    attrs: {
      "type": "file",
      "placeholder": "Upload File",
      "name": "configFile",
      "id": "configFile"
    }
  })]), _vm._v(" "), _c('small', {
    staticClass: "text-muted"
  }, [_c('font', {
    attrs: {
      "color": "red"
    }
  }, [_vm._v("Note: * Only .csv OR .zip files allowed to upload.")])], 1), _vm._v(" "), _c('label', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('configFile')),
      expression: "errors.has('configFile')"
    }],
    staticClass: "text-danger"
  }, [_vm._v("Upload file is required.")])], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-4 expected-column"
  }, [_c('p', {
    staticClass: "expected-title"
  }, [_vm._v("Expected CSV columns")]), _vm._v(" "), _c('div', {
    staticClass: "column-tags"
  }, _vm._l((_vm.expectedColumns), function(column, index) {
    return _c('span', {
      key: index,
      staticClass: "column-tag",
      class: {
        mandatory: column !== 'Layout *'
      }
    }, [_vm._v("\n                        " + _vm._s(column) + "\n                      ")])
  }), 0), _vm._v(" "), _c('p', {
    staticClass: "layout-note"
  }, [_vm._v("\n                      * "), _c('b', [_vm._v("Layout: mandatory for D2B only, blank for all others")])])]), _vm._v(" "), (_vm.failed.length > 0) ? _c('div', {
    staticClass: "col-md-3"
  }, [_c('label', [_vm._v("Download Failed Config")]), _vm._v(" "), _c('b-input-group', {
    staticStyle: {
      "height": "45px"
    },
    attrs: {
      "left": "<i class='fa fa-file-text'></i>"
    }
  }, [_c('span', {
    staticClass: "form-control",
    staticStyle: {
      "cursor": "pointer"
    },
    attrs: {
      "title": "Download Failed Soter Config",
      "target": "_blank"
    },
    on: {
      "click": _vm.exportFailedConfig
    }
  }, [_c('span', {
    staticClass: "form-control",
    staticStyle: {
      "border": "0"
    }
  }, [_vm._v("Download\n                          "), _c('i', {
    staticClass: "fa fa-download",
    staticStyle: {
      "margin-left": "10px",
      "font-size": "18px",
      "color": "red"
    }
  })])])])], 1) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "card-footer"
  }, [_c('button', {
    staticClass: "common-success btn btn-secondary",
    attrs: {
      "type": "submit",
      "title": "Upload Sorter Config File For Selected Sorter Hub"
    }
  }, [_c('i', {
    staticClass: "fa fa-upload"
  }), _vm._v(" Upload")]), _vm._v(" "), _c('button', {
    staticClass: "common-danger btn btn-secondary",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.resetForm
    }
  }, [_vm._v("Reset")])]), _vm._v(" "), _c('div', {
    staticClass: "info-box"
  }, [_c('strong', [_vm._v("Valid Zone Types:")]), _vm._v(" D2B · Secondary Sort · Bagout Shipments · Manifest Inscan\n              ")])])]) : _vm._e(), _vm._v(" "), (_vm.currentTab == 'history') ? _c('b-card', [_c('vue-element-loading', {
    attrs: {
      "spinner": "line-scale",
      "color": "#FF6700",
      "active": _vm.isLoadingSearch
    },
    on: {
      "update:active": function($event) {
        _vm.isLoadingSearch = $event
      }
    }
  }), _vm._v(" "), _c('div', {
    style: (_vm.fileDetails.length > 12 ? 'overflow: auto; height: 395px;' : 'overflow: auto;')
  }, [_c('table', {
    staticClass: "table-bordered table-hover tbl datatables",
    staticStyle: {
      "width": "100%"
    }
  }, [_c('thead', [_c('tr', {
    staticClass: "text-primary"
  }, [_c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("#")]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("Hub Name")]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("File Name")]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("Uploaded By")]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("Uploaded Date")]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("Status")]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("Action")]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("View")])])]), _vm._v(" "), _c('tbody', [_vm._l((_vm.fileDetails), function(data, index) {
    return (_vm.fileDetails.length > 0) ? _c('tr', {
      key: index
    }, [_c('td', {
      staticClass: "text-center",
      attrs: {
        "scope": "row"
      }
    }, [_vm._v(_vm._s(index + 1))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(data.layout))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(data.filename))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(data.createdby))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(_vm._f("moment1")(data.createddate)))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s((data.isactive == true) ? 'Active' : 'Inactive'))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_c('span', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (!data.isactive && index < 6),
        expression: "!data.isactive && index<6"
      }],
      staticStyle: {
        "font-size": "initial",
        "cursor": "pointer",
        "margin-left": "1%",
        "color": "rgb(33, 99, 33)"
      },
      attrs: {
        "checked": data.isactive
      },
      on: {
        "click": function($event) {
          return _vm.selectFile(data)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-check-square-o",
      attrs: {
        "aria-hidden": "true"
      }
    }), _vm._v("  ")]), _vm._v(" "), (data.isactive) ? _c('span', [_vm._v("        ")]) : _vm._e(), _vm._v(" "), _c('span', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (index < 6),
        expression: "index<6"
      }],
      staticStyle: {
        "color": "rgb(208,101,22)",
        "cursor": "pointer"
      },
      attrs: {
        "title": "Download config file"
      },
      on: {
        "click": function($event) {
          return _vm.downloadConfigfromDB(data)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-download"
    })])]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_c('span', {
      staticClass: "fa fa-eye",
      staticStyle: {
        "cursor": "pointer",
        "color": "#20a8d8"
      },
      on: {
        "click": function($event) {
          return _vm.getCameraConfigLogs(data)
        }
      }
    })])]) : _vm._e()
  }), _vm._v(" "), (_vm.fileDetails.length < 1) ? _c('tr', [_c('td', {
    staticClass: "text-center",
    attrs: {
      "colspan": "10"
    }
  }, [_vm._v("No Data Found")])]) : _vm._e()], 2)])])], 1) : _vm._e(), _vm._v(" "), (_vm.currentTab == 'print') ? _c('b-card', [_c('div', {
    staticClass: "card-body1"
  }, [_c('form', {
    staticClass: "form-horizontal"
  }, [_c('b-card', [_c('vue-element-loading', {
    attrs: {
      "spinner": "line-scale",
      "color": "#FF6700",
      "active": _vm.isLoading
    },
    on: {
      "update:active": function($event) {
        _vm.isLoading = $event
      }
    }
  }), _vm._v(" "), _c('fieldset', [_c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-4"
  }, [_c('b-form-fieldset', [_c('label', [_vm._v("Zone Type")]), _c('span', {
    staticClass: "text-danger"
  }, [_vm._v("*")]), _vm._v(" "), _c('multiselect', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: _vm.zoneType.length === 0
      }),
      expression: "{required: zoneType.length === 0}"
    }],
    attrs: {
      "options": _vm.listZoneTypeData,
      "multiple": true,
      "close-on-select": false,
      "clear-on-select": false,
      "placeholder": "Select Zone Type",
      "label": "text",
      "track-by": "id",
      "name": "zoneType"
    },
    on: {
      "input": function($event) {
        return _vm.selectZoneType(_vm.zoneType)
      }
    },
    model: {
      value: (_vm.zoneType),
      callback: function($$v) {
        _vm.zoneType = $$v
      },
      expression: "zoneType"
    }
  }), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('zoneType')),
      expression: "errors.has('zoneType')"
    }],
    staticClass: "text-danger"
  }, [_vm._v("The Zone Type is required.")])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('b-form-fieldset', [_c('label', [_vm._v("Zone Name")]), _vm._v(" "), _c('multiselect', {
    attrs: {
      "options": _vm.listZoneNameData,
      "multiple": true,
      "close-on-select": false,
      "clear-on-select": false,
      "placeholder": "Select Zone Name",
      "label": "text",
      "track-by": "id",
      "name": "zoneName",
      "disabled": !_vm.zoneType || _vm.zoneType.length === 0
    },
    on: {
      "input": function($event) {
        return _vm.selectZoneName(_vm.zoneName)
      }
    },
    model: {
      value: (_vm.zoneName),
      callback: function($$v) {
        _vm.zoneName = $$v
      },
      expression: "zoneName"
    }
  }), _vm._v(" "), _c('span', {
    staticStyle: {
      "font-size": "0.8em"
    }
  }, [_vm._v(_vm._s(_vm.hubLoading))]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('zoneName')),
      expression: "errors.has('zoneName')"
    }],
    staticClass: "text-danger"
  }, [_vm._v("The Zone Name field is\n                            required.")])], 1)], 1)])])], 1)], 1)]), _vm._v(" "), _c('div', {
    style: (_vm.qrZoneDetails.length > 8 ? 'overflow: auto; height: 395px;' : 'overflow: auto;')
  }, [_c('table', {
    staticClass: "table-bordered table-hover tbl datatables",
    staticStyle: {
      "width": "100%"
    }
  }, [_c('thead', [_c('tr', {
    staticClass: "text-primary"
  }, [_c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("Zone Type")]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("Zone Name")]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("QR string")])])]), _vm._v(" "), _c('tbody', [_vm._l((_vm.qrZoneDetails), function(data, index) {
    return (_vm.qrZoneDetails.length > 0) ? _c('tr', {
      key: index
    }, [_c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(data.zone_type))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(data.bay_zone))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(data.qr_string))])]) : _vm._e()
  }), _vm._v(" "), (_vm.qrZoneDetails.length < 1) ? _c('tr', [_c('td', {
    staticClass: "text-center",
    attrs: {
      "colspan": "10"
    }
  }, [_vm._v("No Data Found")])]) : _vm._e()], 2)])]), _vm._v(" "), _c('div', {
    staticClass: "action-buttons"
  }, [_c('button', {
    staticClass: "btn btn-success",
    on: {
      "click": _vm.printQRs
    }
  }, [_vm._v("Print QR Codes")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-danger",
    on: {
      "click": _vm.resetPrint
    }
  }, [_vm._v("Reset")])])]) : _vm._e()], 1)], 1)])]), _vm._v(" "), _c('b-modal', {
    attrs: {
      "id": "#confirmationmodal",
      "title": "Confirmation"
    },
    on: {
      "click": function($event) {
        _vm.addmodalShow = false
      }
    },
    model: {
      value: (_vm.addmodalShow),
      callback: function($$v) {
        _vm.addmodalShow = $$v
      },
      expression: "addmodalShow"
    }
  }, [_c('div', {
    attrs: {
      "role": "document"
    }
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_c('div', {
    staticClass: "modal-headerfrm"
  }, [_c('h4', {
    staticClass: "modal-title"
  }, [_vm._v("Confirmation")]), _vm._v(" "), _c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "modal",
      "aria-label": "Close"
    },
    on: {
      "click": _vm.closeStatusModal
    }
  }, [_c('span', {
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("×")])])]), _vm._v(" "), _c('div', {
    staticClass: "modal-bodyfrm"
  }, [_c('p', [_vm._v("Do you want to activate this file?")])]), _vm._v(" "), _c('div', {
    staticClass: "modal-footerfrm",
    staticStyle: {
      "text-align": "right"
    }
  }, [_c('button', {
    staticClass: "btn btn-success",
    attrs: {
      "type": "button"
    },
    on: {
      "click": [_vm.takeAction, function($event) {
        _vm.addmodalShow = false
      }]
    }
  }, [_vm._v("Save")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-danger",
    attrs: {
      "type": "button",
      "data-dismiss": "modal"
    },
    on: {
      "click": _vm.closeStatusModal
    }
  }, [_vm._v("Cancel")])])])])]), _vm._v(" "), (_vm.showModal == true) ? _c('b-modal', {
    attrs: {
      "size": "vlg",
      "title": "Sorter Config Logs"
    },
    model: {
      value: (_vm.showModal),
      callback: function($$v) {
        _vm.showModal = $$v
      },
      expression: "showModal"
    }
  }, [_c('div', {
    attrs: {
      "role": "document"
    }
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_c('div', {
    staticClass: "modal-headerfrm"
  }, [_c('h4', {
    staticClass: "modal-title"
  }, [_vm._v("Camera Config File Logs")]), _vm._v(" "), _c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "modal",
      "aria-label": "Close"
    },
    on: {
      "click": _vm.closeModal
    }
  }, [_c('span', {
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("×")])])]), _vm._v(" "), _c('div', {
    staticClass: "modal-bodyfrm",
    staticStyle: {
      "overflow": "auto",
      "height": "150px",
      "margin-top": "00px"
    }
  }, [_c('table', {
    staticClass: "table-bordered table-hover tbl datatables",
    staticStyle: {
      "width": "100%"
    }
  }, [_c('thead', [_c('tr', {
    staticClass: "text-primary"
  }, [_c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("#")]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("Hub id")]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("Hub Name")]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("Action")]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("User")]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("Date")])])]), _vm._v(" "), _c('tbody', _vm._l((_vm.configFileLogs), function(data, index) {
    return _c('tr', [_c('td', {
      staticClass: "text-center",
      attrs: {
        "scope": "row"
      }
    }, [_vm._v(_vm._s(index + 1))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(data.hub_id) + " ")]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(data.facility_name))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(data.action))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(data.createdby))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(_vm._f("moment")(data.createddate)))])])
  }), 0)])]), _vm._v(" "), _c('div', {
    staticClass: "modal-footerfrm"
  }, [_c('button', {
    staticClass: "common-danger",
    attrs: {
      "type": "button",
      "data-dismiss": "modal"
    },
    on: {
      "click": _vm.closeModal
    }
  }, [_vm._v("Close")])])])])]) : _vm._e()], 1)
}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card-body1",
    staticStyle: {
      "margin-bottom": "0.5%",
      "background-color": "white"
    }
  }, [_c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('legend', {
    staticStyle: {
      "border": "0px"
    }
  }, [_vm._v("Camera Master")])])])])
}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-58a7fd58","hasScoped":true}!./src/views/components/CameraMaster/CameraMaster.html
// module id = 2056
// module chunks = 2